module.exports = __webpack_public_path__ + "media/images/prifile_icon-176d998d06c46898eedb140cfbf9baab.svg";